import React from "react";
import { cn } from "@utils/utils";
import { Skeleton } from "../ui/skeleton";

interface QuadrantLoaderProps {
  className?: string;
}
const QuadrantLoader: React.FC<QuadrantLoaderProps> = ({ className }) => {
  return (
    <div
      className={cn(
        "h-full w-full flex p-6 justify-center items-center bg-primary-background rounded-md border border-gray-800",
        className,
      )}
    >
      <div className="grid grid-cols-2 grid-rows-2 gap-2">
        <Skeleton className="h-[20vh] w-[40vw] bg-secondary text-center animate-pulse" />
        <Skeleton className="h-[20vh] w-[40vw] bg-secondary text-center animate-pulse" />
        <Skeleton className="h-[20vh] w-[40vw] bg-secondary text-center animate-pulse" />
        <Skeleton className="h-[20vh] w-[40vw] bg-secondary text-center animate-pulse" />
      </div>
    </div>
  );
};

export default QuadrantLoader;
